export const dummyArray = [
    {
        id: 1,
        name: '1003010001',
        category: 'lddddd',
        class: 'Steel1',
        shortText: 'STEEL,MATERIAL,34,F/LABOUR',
        longText: 'STEEL,MATERIAL,35,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'


    },
    {
        id: 2,
        name: '1003010002',
        category: 'Material1',
        class: 'Steel2',
        shortText: 'STEEL,MATERIAL,36,F/LABOUR1',
        longText: 'STEEL,MATERIAL,37,F/',
        uom: '$PAA1',
        manufacturer: 'Text1',
        manufectureModel: 'Text1'
    },
    {
        id: 3,
        name: '1003010003',
        category: 'Material2',
        class: 'Steel2',
        shortText: 'STEEL,MATERIAL,38,F/LABOUR2',
        longText: 'STEEL,MATERIAL,39,F/3',
        uom: '$PAA2',
        manufacturer: 'Text2',
        manufectureModel: 'Text2'
    },
    {
        id: 4,
        name: '1003010004',
        category: 'Material3',
        class: 'Steel3',
        shortText: 'STEEL,MATERIAL,41,F/LABOUR3',
        longText: 'STEEL,MATERIAL,42,F/',
        uom: '$PAA3',
        manufacturer: 'Text3',
        manufectureModel: 'Text3'
    },
    {
        id: 5,
        name: '1003010005',
        category: 'Material4',
        class: 'Steel5',
        shortText: 'STEEL,MATERIAL,43,F/LABOUR',
        longText: 'STEEL,MATERIAL,44,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 6,
        name: '1003010006',
        category: 'Material',
        class: 'Steel5',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 7,
        name: '1003010007',
        category: 'Material5',
        class: 'Steel6',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 8,
        name: '1003010001',
        category: 'Material6',
        class: 'Steel7',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 9,
        name: '1003010008',
        category: 'Material7',
        class: 'Steel8',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 10,
        name: '1003010001',
        category: 'Material8',
        class: 'Steel9',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 11,
        name: '1003010009',
        category: 'Material9',
        class: 'Steel10',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 12,
        name: '1003010001',
        category: 'Material10',
        class: 'Steel11',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 13,
        name: '10030100010',
        category: 'Material',
        class: 'Steel12',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 14,
        name: '1003010001',
        category: 'Material',
        class: 'Steel13',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 15,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 16,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 17,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 18,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 19,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 20,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 21,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 22,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 23,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 24,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 25,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 26,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 27,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 28,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 29,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 30,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 31,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 32,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 33,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 34,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 35,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 36,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 37,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 38,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 39,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 40,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 41,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 42,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 43,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 44,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 45,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 46,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 47,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 48,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 49,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 50,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 51,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 52,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 52,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 54,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 55,
        name: '1003010001',
        category: 'Material',
        class: 'Steel',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text',
    },
    {
        id: 56,
        name: '1003010001',
        category: 'Material',
        class: 'Steel19',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
    {
        id: 57,
        name: '1003010001',
        category: 'Material',
        class: 'Steel10',
        shortText: 'STEEL,MATERIAL,40,F/LABOUR',
        longText: 'STEEL,MATERIAL,40,F/',
        uom: '$PAA',
        manufacturer: 'Text',
        manufectureModel: 'Text'
    },
]